export default "__VITE_ASSET__BqR6zIKy__"